import gql from "graphql-tag";

export const changeAssetSpaceMutation = gql`
  mutation ChangeAssetSpace($eventId: ID, $graphicSetId: ID, $assetId: ID) {
    changeAssetSpace(eventId: $eventId, graphicSetId: $graphicSetId, assetId: $assetId) {
      id
    }
  }
`;
